import React from 'react';
import { useSelector } from 'react-redux';
import { localeSelector } from 'src/selector/app';
import FullServicePageContent from 'src/consts/poswebsite_content/full_service';
import ServiceTypePage from 'src/components/POSWebsite/Pages/ServiceTypePage';
import { PRODUCTS } from 'src/consts/poswebsite_content/everythingNeedInOnePOSSystem';

const FullService = () => {
  const locale = useSelector(localeSelector);

  return (
    <ServiceTypePage
      pageId={'pos-full-service'}
      pageContent={FullServicePageContent}
      featureCardStyle="border_card"
      whyChowbusShowModel="lightGray"
      productsNeedInOnePOSSystem={[
        PRODUCTS.PRODUCT_POINT_OF_SALE,
        PRODUCTS.PRODUCT_POS_HANDHELD,
        PRODUCTS.PRODUCT_TABLET_ORDERING,
        PRODUCTS.PRODUCT_QRCODE_ORDERING,
        PRODUCTS.PRODUCT_LOYALTY,
        PRODUCTS.PRODUCT_THIRD_PARTY_INTEGRATION,
        PRODUCTS.PRODUCT_WAITLIST,
        PRODUCTS.PRODUCT_KIOSK,
        PRODUCTS.PRODUCT_ONLINE_ORDERING,
      ]}
      customerCaseKeys={['/for-home/korean-bbq/jongro-bbq', '/sushi-ramen/shinya-ramen-house']}
    />
  );
};

export default FullService;

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}
